// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__+NC3p","corner":"checkbox_corner__gzGjC","checkmark-container":"checkbox_checkmark-container__Ovo8o"};